import { render } from "./NotaSpese.vue?vue&type=template&id=7ea59290&scoped=true&ts=true"
import script from "./NotaSpese.vue?vue&type=script&lang=ts"
export * from "./NotaSpese.vue?vue&type=script&lang=ts"

import "./NotaSpese.vue?vue&type=style&index=0&id=7ea59290&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_perla_1768301730385742645/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea59290"]])

export default __exports__